"use strict";

function isUrlValid(url) {
  var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
  return regex.test(url);
}

function sglClick($parse) {
  return {
    restrict: 'A',
      link: function(scope, element, attr) {
        var fn = $parse(attr['sgl-click']);
        var delay = 300, clicks = 0, timer = null;
        element.on('click', function (event) {
          clicks++;
          if(clicks === 1) {
            timer = setTimeout(function() {
              scope.$apply(function () {
                fn(scope, { $event: event });
              }); 
              var text = attr['sglClick'];
              if (isUrlValid(text)) {
                window.open(text, '_blank');
              }  
              clicks = 0;  
            }, delay);
          } else {
            clearTimeout(timer); 
            clicks = 0;   
          }
        });
      }
  };
}

angular.module("dokiv")
  .directive("sglClick", ["$parse", sglClick]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/sglClick.js
// module id = 271
// module chunks = 0